import { money } from "@/lib/money"

/** The plan's base bid — the ✓ rows priced at their picked levels; what
 *  the builder's base house costs. Server-computed lines and total. */
export function BaseBidCard({
  planLabel,
  lines,
  total,
}: {
  planLabel: string
  lines: { label: string; amount: string }[]
  total: string
}) {
  return (
    <section
      className="rounded-lg border border-hairline bg-surface p-4"
      data-testid="base-bid-card"
    >
      <h2>{planLabel} — base bid</h2>
      {lines.length === 0 ? (
        <p className="mt-2 text-sm text-ink-muted">
          Nothing picked yet — check a level per room in the matrix. Everything outside the ✓ rows
          is upgrade revenue.
        </p>
      ) : (
        <dl className="mt-3 grid grid-cols-[1fr_auto] gap-y-1.5 text-sm">
          {lines.map((line) => (
            <div key={line.label} className="contents">
              <dt className="text-ink-muted">{line.label}</dt>
              <dd className="text-right tabular-nums">{money(line.amount)}</dd>
            </div>
          ))}
          <dt className="border-t border-hairline pt-1.5">
            <strong>Base bid total</strong>
          </dt>
          <dd className="border-t border-hairline pt-1.5 text-right tabular-nums">
            <strong data-testid="base-bid-total">{money(total)}</strong>
          </dd>
        </dl>
      )}
    </section>
  )
}
